import invariant from 'invariant'
import { createContext, useContext } from 'react'

import { SystemConfiguration } from '../../../types'
import { Nullable } from '@signavio/effektif-commons'

export const SystemConfigurationContext =
  createContext<Nullable<SystemConfiguration>>(null)

export const useSystemConfiguration = () => {
  const systemConfiguration = useContext(SystemConfigurationContext)

  invariant(
    systemConfiguration,
    'No system configuration on context even though one was expected.'
  )

  return systemConfiguration
}
